//Libraries
import { useState } from "react";
import { useUser } from "@auth0/nextjs-auth0";

//Components
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PrivacyPolicy({}) {
  const { user, error, isLoading } = useUser();

  const [cart, setCart] = useState([]);

  return (
    <div className="bg-white pt-20 overscroll-y-none">
      {/* Menu */}
      <Header user={user} cart={cart} setCart={setCart} />

      <div className="py-6 px-12">
        <h1 className="my-8 text-gindo text-3xl font-bold">Aviso de Privacidad para Among Wings</h1>
        <div className="my-4 space-y-4 text-justify bg-watermark bg-repeat-y bg-right bg-auto">
          <>
            <table className="min-w-full divide-y divide-gray-300">
              <tbody>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Identidad y domicilio del Responsable</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>La sociedad responsable del tratamiento de sus datos será AMONG WINGS, LLC/S.A. de C.V. (“Responsable”) con domicilio en [Coastal Highway Num.ext. 16192, Lewes, County of Sussex, Delaware 19958, Estados Unidos de America].</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Servicios</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>Los servicios consisten en poner a su disposición una plataforma tecnológica que le permite consultar, publicar acceder, ofrecer, adquirir y contratar productos, servicios, funciones, materiales, clases y demás contenido de interés (“Servicios”).</p>
                    <p>Los Servicios le ofrecen la posibilidad de explorar, ver, compartir, cargar, exhibir, mostrar y revelar videos, fotos, comentarios y otros contenidos, además de la obtención de artículos de arte.</p>
                    <p>
                      A través de la Plataforma puede conectar con otros usuarios para informarse sobre los temas de su preferencia, conectar con artistas y descubrir herramientas y materiales novedosos. Además, sirve como plataforma de distribución y venta para creadores de contenido original y
                      para anunciantes de todo tipo.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Categorías de datos personales sujetas al tratamiento</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>Para cumplir con las finalidades del tratamiento señaladas en el presente aviso de privacidad, es necesario recabar y dar tratamiento a los siguientes datos personales:</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos de identificación</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos de contacto</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos de ubicación</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos académicos</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos laborales</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos que usted proporcione voluntariamente para generar su perfil</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Su imagen personal a través de las fotografías y/o videos que de forma voluntaria usted comparta mediante el uso de la Plataforma</p>
                    <p>
                      •&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Información técnica del dispositivo que usted emplee para acceder a nuestros Servicios, incluyendo datos relativos a las características del equipo, localización geográfica del dispositivo e información que se genere a partir del uso de la
                      Aplicación incluyendo datos bancarios que sean necesarios para efectuar operaciones de compra y venta en la Aplicación.
                    </p>
                    <p>&nbsp;</p>
                    <p>En caso de que usted se registre a la aplicación a través de su perfil de Google, podremos recabar los datos de inicio de sesión en dichas plataformas, así como los datos que usted haya hecho públicos a través de su perfil en dichas plataformas.</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Tratamiento de datos personales sensibles</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>Para efectos del presente Aviso de Privacidad, el Responsable no dará tratamiento a datos personales de carácter sensible.</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Finalidades primarias</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>El Responsable tratará sus datos personales para realizar las siguientes finalidades primarias:</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para prestarle los Servicios de conformidad con los Términos y Servicios que regulan la relación jurídica con usted.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para identificarle y permitirle realizar su registro dentro de la Plataforma con el fin de crearle un perfil.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para comprobar la veracidad de la información que nos proporciona.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para que pueda hacer uso de las funcionalidades de la Plataforma.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para hacer público su perfil para que terceros puedan contactarle.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para permitir su interacción con usuarios de la Plataforma.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para gestionar las transacciones que lleve a cabo dentro de la Plataforma.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para realizarle la entrega de los productos que usted obtenga a través de la Plataforma.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para llevar un registro de las operaciones que lleve a cabo en la Plataforma.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para identificar y prevenir posibles conductas ilícitas que pudieran significar una violación de las disposiciones legales vigentes o de nuestros Términos y Condiciones.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para atender sus consultas, aclaraciones y/o reclamaciones en relación con los Servicios.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para dar cumplimiento a nuestras obligaciones y/o requerimientos por partes de autoridades competentes en términos de la normatividad aplicable.</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Dar cumplimiento a obligaciones previstas en la normatividad aplicable.</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Finalidades secundarias</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>Si usted no se opone, y en caso de que le sea aplicable, el Responsable tratará sus datos personales para las siguientes finalidades:</p>
                    <ul>
                      <li>Contactarle para invitarle a participar en encuestas y/o formularios de datos.</li>
                      <li>Para conocer sus preferencias de consumo.</li>
                      <li>Mostrarle y/o enviarle publicidad que pueda resultar de su interés.</li>
                      <li>Realizar actividades de análisis de la información y datos relacionados con su persona mediante la aplicación de diversas técnicas y tecnologías de análisis de datos que nos permitirán conocer mejor su perfil, aptitudes e intereses.</li>
                      <li>Para fines estadísticos.</li>
                      <li>Llevar a cabo actividades de perfilamiento de acuerdo con la información relativa a sus hábitos y preferencias de consumo, así como aquella derivada del uso de técnicas de análisis de datos.</li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>En caso de que no desee que sus datos personales sean tratados para alguna o todas las finalidades adicionales, desde este momento usted nos puede comunicar lo anterior al correo: &nbsp;legal@amongwings.com</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Transferencias</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>El Responsable podrá transferir sus datos personales, tanto a entidades nacionales como extranjeras, sin requerir de su consentimiento a:</p>
                    <p>
                      •&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Empresas afiliadas, subsidiarias y/o entidades controladoras, nacionales o extranjeros, que operan bajo las mismas políticas internas en materia de protección de datos personales para las finalidades informadas en el presente Aviso de
                      Privacidad.
                    </p>
                    <p>&nbsp;</p>
                    <p>•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Autoridades competentes en los casos previstos por la normatividad aplicable.</p>
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Medios para ejercer Derechos ARCO</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>
                      Usted o su representante legal podrá ejercer cualquiera de los derechos de acceso, rectificación, cancelación u oposición (en lo sucesivo “Derechos ARCO”), así como revocar su consentimiento para el tratamiento de sus datos personales enviando un correo electrónico a nuestro
                      Departamento de Protección de Datos Personales a la dirección de correo: legal@amongwings.com donde se le atenderá en tiempo y forma.
                    </p>
                    <p>
                      Para que nuestro Departamento de Protección de Datos Personales pueda darle seguimiento a su solicitud, usted o su representante legal deberá acreditar correctamente su identidad acompañando a su solicitud una copia de alguna de las identificaciones oficiales vigentes que se
                      señalan en el mismo.
                    </p>
                    <p>
                      En caso de que la información proporcionada sea errónea o insuficiente, o bien, no se acompañen los documentos de acreditación correspondientes, nuestro Departamento de Protección de Datos Personales, dentro de los cinco (5) días hábiles siguientes a la recepción de la
                      solicitud, podrá requerirle que aporte los elementos o documentos necesarios para dar trámite a la misma. Usted contará con diez (10) días hábiles para atender el requerimiento, contados a partir del día siguiente en que lo haya recibido. De no dar respuesta en dicho plazo, se
                      tendrá por no presentada la solicitud correspondiente.
                    </p>
                    <p>
                      Nuestro Departamento de Protección de Datos Personales le comunicará la determinación adoptada, en un plazo máximo de veinte (20) días hábiles contados desde la fecha en que se recibió la solicitud, a efecto de que, si resulta procedente, haga efectiva la misma dentro de los
                      quince (15) días hábiles siguientes a que se comunique la respuesta.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Opciones y medios para limitar el uso o divulgación de sus datos&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; personales</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>
                      Usted podrá limitar el uso o divulgación de sus datos personales enviando su solicitud a nuestro Departamento de Protección de Datos Personales a la dirección de correo: <a href="mailto:legal@amongwings.com">legal@amongwings.com</a> &nbsp;Los requisitos para acreditar su
                      identidad, así como el procedimiento para atender su solicitud se regirán por los mismos criterios señalados en el apartado anterior.
                    </p>
                    <p>En caso de que su solicitud resulte procedente, nuestro Departamento de Protección de Datos Personales lo registrará en el listado de exclusión propio del Responsable.</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Uso de cookies y web beacons</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>
                      El Responsable utiliza varias tecnologías para mejorar la eficiencia de nuestros sitios web y herramientas tecnológicas, incluyendo su experiencia cuando navega por dichos sitios o usa nuestra red. Entre estas tecnologías se incluye el uso de cookies, que son pequeñas
                      cantidades de información que se almacenan en el navegador utilizado por cada usuario para que el servidor recuerde cierta información que posteriormente pueda utilizar. Esta información permite identificarle y guardar sus preferencias personales para brindarle una mejor
                      experiencia de navegación.
                    </p>
                    <p>En nuestros sitios de internet y aplicaciones podemos hacer uso de cookies, web beacons y otras tecnologías de rastreo, propias y de terceros que nos permiten cumplir con las finalidades informadas en el presente Aviso de Privacidad.</p>
                    <p>Los diferentes tipos de cookies que utilizamos para obtener datos identificativos y datos relacionados con su comportamiento de compra y uso de servicios en internet son:</p>
                    <p>
                      ·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Cookies esenciales:</strong>&nbsp; Utilizamos estas tecnologías para permitirle un uso adecuado de nuestros sitios web, por lo que las mismas no pueden ser deshabilitadas al ser necesarias para permitirle el uso de las
                      funcionalidades de nuestros sitios web y herramientas tecnológicas.
                    </p>
                    <p>
                      ·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Cookies para recordar sus preferencias y experiencia:</strong> A través de estas tecnologías obtenemos horario de navegación, tiempo de navegación en nuestra página de Internet, secciones consultadas, y páginas de
                      Internet accedidas previo a la nuestra, estas cookies nos permiten recordar sus preferencias, opciones de navegación y funciones personalizadas.
                    </p>
                    <p>
                      ·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Cookies para objetivos de rendimiento y análisis:</strong>
                      &nbsp; Podemos usar cookies propias y de terceros para obtener datos de carácter técnico y estadístico que nos permitan identificar la forma en la cual usted hace uso de nuestros servicios con la finalidad de mejorar su rendimiento y futuros desarrollos.
                    </p>
                    <p>
                      ·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Cookies publicitarias propias y de terceros: </strong>
                      Podemos colocar cookies publicitarias propias y de terceros (como socios comerciales y Empresas del Grupo) para obtener información relativa a sus preferencias de compra, consumo y visualización de sitios web para mostrarle publicidad que consideremos relevante para usted.
                    </p>
                    <p>
                      ·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Otros datos:</strong> De la misma forma, como parte de nuestros procesos de mejora de nuestros productos y servicios, en ciertos casos podremos recabar respuestas anónimas a encuestas y requerimientos relacionados con el
                      uso de nuestros productos y servicios. En determinados casos y cuando ello sea necesario podremos aplicar técnicas de anonimización de datos con la finalidad de realizar determinados estudios de carácter predictivo y estadístico a partir de la información generada con motivo
                      del uso de nuestros Servicios.
                    </p>
                    <p>Algunas de las cookies que utilizamos en nuestro Sitio Web son necesarias para permitir su funcionamiento y no se pueden desactivar de nuestros sistemas.</p>
                    <p>No obstante, usted puede deshabilitar aquellas cookies no esenciales, siguiendo el aplicable de acuerdo con el tipo de navegador que utilice para acceder a nuestro Sitio Web:</p>
                    <p>
                      (i) Internet Explorer: Herramientas -&gt; Opciones de Internet -&gt; Privacidad -&gt; Configuración. Para más información, puede consultar el siguiente <a href="http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies">enlace</a>
                    </p>
                    <p>
                      (ii) Firefox: Herramientas -&gt; Opciones -&gt; Privacidad y Seguridad. Para más información, puede consultar el siguiente <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias">enlace</a>.
                    </p>
                    <p>
                      (iii) Chrome: Configuración -&gt; Verificación de seguridad y/o -&gt; Privacidad y seguridad. Para más información, puede consultar el siguiente <a href="https://support.google.com/chrome/answer/95647?hl=es">enlace</a>.
                    </p>
                    <p>
                      (iv) Safari: Preferencias -&gt; Seguridad. Para más información, puede consultar el siguiente <a href="https://support.apple.com/kb/PH19214?&viewlocale=es_ES">enlace</a>.
                    </p>
                    <p>
                      (v) Opera: Configuración -&gt; Privacidad, búsqueda y servicios y/o Permisos del sitio. Para más información, puede consultar el siguiente <a href="http://www.opera.com/help/tutorials/security/cookies/">enlace</a>.
                    </p>
                    <p>A través de su navegador de internet, usted también puede ver las cookies que están en su dispositivo, y borrarlas según crea conveniente.</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Cambios al Aviso de Privacidad</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>
                      EL RESPONSABLE se reserva el derecho, bajo su exclusiva discreción, de cambiar, modificar, agregar o eliminar partes del presente Aviso de Privacidad en cualquier momento. En tal caso, EL RESPONSABLE le informará de los cambios por el mismo medio que ha puesto a su disposición
                      este Aviso de Privacidad.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Última actualización</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>2024.{process.env.NEXT_ENV}.</p>
                  </td>
                </tr>
                <tr>
                  <td width={150} className="p-4 border">
                    <p>
                      <strong>Aceptación</strong>
                    </p>
                  </td>
                  <td width={438} className="p-4 border">
                    <p>
                      Al realizar su registro en el portal del sitio web/aplicación y proporcionar sus datos personales en el formulario respectivo, usted acepta y reconoce que ha leído el presente Aviso de Privacidad y nos autoriza para dar tratamiento a sus datos personales de conformidad con lo
                      señalado en este Aviso de Privacidad.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
          </>
        </div>
      </div>

      <Footer />
    </div>
  );
}
